import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=6b62e586&scoped=true&lang=pug&"
import script from "./Quiz.vue?vue&type=script&lang=js&"
export * from "./Quiz.vue?vue&type=script&lang=js&"
import style0 from "./Quiz.vue?vue&type=style&index=0&id=6b62e586&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62e586",
  null
  
)

export default component.exports